<div class="generalPage" aria-label="help browsing" role="main">
  <div class="pr-22 content-container pb-0 print-all-content">
    <h1 class="generalHeader margin-0 content-blue bold itcHeavyFont generalHeader" role="heading">{{cap_header}}</h1>
    <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]="cap_desc"></p>
  </div>
</div>
